import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        await supabase.from('page_visits').insert({
          page: location.pathname,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent || null,
          country: null,
        });
      } catch {
        // silent fail
      }
    };
    trackVisit();
  }, [location.pathname]);
};
